// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lds-grid div {
  animation: lds-grid 1.2s linear infinite;
  position: absolute;
  width: 1rem /* 16px */;
  height: 1rem /* 16px */;
  border-radius: 50%;

  /* bg-white */
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.lds-grid div:nth-child(1) {
  animation-delay: 0s;
  top: 0.5rem /* 8px */;
  left: 0.5rem /* 8px */;
}
.lds-grid div:nth-child(2) {
  animation-delay: -0.4s;
  top: 0.5rem /* 8px */;
  left: 2rem /* 32px */;
}
.lds-grid div:nth-child(3) {
  animation-delay: -0.8s;
  top: 0.5rem /* 8px */;
  left: 3.5rem /* 56px */;
}
.lds-grid div:nth-child(4) {
  animation-delay: -0.4s;
  top: 2rem /* 32px */;
  left: 0.5rem /* 8px */;
}
.lds-grid div:nth-child(5) {
  animation-delay: -0.8s;
  top: 2rem /* 32px */;
  left: 2rem /* 32px */;
}
.lds-grid div:nth-child(6) {
  animation-delay: -1.2s;
  top: 2rem /* 32px */;
  left: 3.5rem /* 56px */;
}
.lds-grid div:nth-child(7) {
  top: 56px;
  left: 8px;
  animation-delay: -0.8s;
  top: 3.5rem /* 56px */;
  left: 0.5rem /* 8px */;
}
.lds-grid div:nth-child(8) {
  animation-delay: -1.2s;
  top: 3.5rem /* 56px */;
  left: 2rem /* 32px */;
}
.lds-grid div:nth-child(9) {
  animation-delay: -1.6s;
  top: 3.5rem /* 56px */;
  left: 3.5rem /* 56px */;
}
@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.preloading-text {
  font-family: 'Roboto', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/Preloading.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;;EAElB,aAAa;EACb,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".lds-grid div {\n  animation: lds-grid 1.2s linear infinite;\n  position: absolute;\n  width: 1rem /* 16px */;\n  height: 1rem /* 16px */;\n  border-radius: 50%;\n\n  /* bg-white */\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.lds-grid div:nth-child(1) {\n  animation-delay: 0s;\n  top: 0.5rem /* 8px */;\n  left: 0.5rem /* 8px */;\n}\n.lds-grid div:nth-child(2) {\n  animation-delay: -0.4s;\n  top: 0.5rem /* 8px */;\n  left: 2rem /* 32px */;\n}\n.lds-grid div:nth-child(3) {\n  animation-delay: -0.8s;\n  top: 0.5rem /* 8px */;\n  left: 3.5rem /* 56px */;\n}\n.lds-grid div:nth-child(4) {\n  animation-delay: -0.4s;\n  top: 2rem /* 32px */;\n  left: 0.5rem /* 8px */;\n}\n.lds-grid div:nth-child(5) {\n  animation-delay: -0.8s;\n  top: 2rem /* 32px */;\n  left: 2rem /* 32px */;\n}\n.lds-grid div:nth-child(6) {\n  animation-delay: -1.2s;\n  top: 2rem /* 32px */;\n  left: 3.5rem /* 56px */;\n}\n.lds-grid div:nth-child(7) {\n  top: 56px;\n  left: 8px;\n  animation-delay: -0.8s;\n  top: 3.5rem /* 56px */;\n  left: 0.5rem /* 8px */;\n}\n.lds-grid div:nth-child(8) {\n  animation-delay: -1.2s;\n  top: 3.5rem /* 56px */;\n  left: 2rem /* 32px */;\n}\n.lds-grid div:nth-child(9) {\n  animation-delay: -1.6s;\n  top: 3.5rem /* 56px */;\n  left: 3.5rem /* 56px */;\n}\n@keyframes lds-grid {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.preloading-text {\n  font-family: 'Roboto', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
